import React from 'react'

/* eslint-disable @stylistic/max-len */

export const csvFileIcon = (
  <svg viewBox="0 0 44 54" version="1.1" preserveAspectRatio="xMidYMid meet">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-938.000000, -435.000000)">
        <g transform="translate(938.000000, 435.000000)">
          <g fill="currentColor" fillRule="nonzero">
            <path d="M43.5611892,18.12 C43.5463243,18.0462 43.518973,17.976 43.4862703,17.9082 L43.4601081,17.8584 C43.4226486,17.7918 43.3792432,17.7288 43.3251351,17.6736 L26.0628649,0.255 C26.0087568,0.2004 25.9463243,0.1572 25.8815135,0.1194 L25.8291892,0.0912 C25.7637838,0.0588 25.696,0.0324 25.6246486,0.0174 L25.6157297,0.0162 C25.5622162,0.006 25.5075135,0 25.4522162,0 L8.49675676,0 C4.04443243,0 0.422162162,3.6552 0.422162162,8.1486 L0.422162162,45.8514 C0.422162162,50.3442 4.04443243,54 8.49675676,54 L35.5032432,54 C39.9561622,54 43.5784324,50.3442 43.5784324,45.8514 L43.5784324,18.2904 C43.5784324,18.2334 43.5730811,18.1764 43.5617838,18.1212 L43.5617838,18.12 L43.5611892,18.12 Z M40.631027,17.4192 L32.3572432,17.4192 C29.0257297,17.4192 26.3155676,14.6844 26.3155676,11.3226 L26.3155676,2.9736 L40.631027,17.4192 Z M35.5032432,52.2582 L8.49675676,52.2582 C4.99578378,52.2582 2.14827027,49.3836 2.14827027,45.8514 L2.14827027,8.1486 C2.14827027,4.6158 4.99637838,1.7424 8.49675676,1.7424 L24.5894595,1.7424 L24.5894595,11.3232 C24.5894595,15.6456 28.0737838,19.1622 32.3578378,19.1622 L41.8523243,19.1622 L41.8523243,45.852 C41.8517297,49.3836 39.0042162,52.2582 35.5032432,52.2582 Z" />
          </g>
          <path
            d="M20,28 L42,28 L42,42 L20,42 C16.6862915,42 14,39.3137085 14,36 L14,34 C14,30.6862915 16.6862915,28 20,28 Z"
            fill="currentColor"
          />
          <text fontFamily="ProximaNova" fontSize="10" fill="#FFFFFF">
            <tspan x="20" y="38">
              CSV
            </tspan>
          </text>
        </g>
      </g>
    </g>
  </svg>
)

export const uploadFileIcon = (
  <svg viewBox="0 0 44 41" version="1.1" preserveAspectRatio="xMidYMid meet">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g transform="translate(-611.000000, -428.000000)" stroke="currentColor" strokeWidth="2.25">
        <g transform="translate(612.000000, 429.000000)">
          <polyline points="14.1272727 27.375 0.381818182 27.375 0.381818182 0.375 41.6181818 0.375 41.6181818 27.375 27.8727273 27.375" />
          <polyline points="30.1407273 18.375 20.9770909 9.375 11.8134545 18.375" />
          <path d="M7.25454545,38.625 L11.8363636,38.625 C16.8973003,38.625 21,34.5955627 21,29.625 L21,9.375" />
        </g>
      </g>
    </g>
  </svg>
)
